import { FormattedPolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { PolicyComponentAssociatedPolicy } from "@idw-types/policy-component-associated-policy";

export enum PolicyComponentDetailsActionTypes {
    SET_POLICY_COMPONENT_DETAILS_LOADING = "SET_POLICY_COMPONENT_DETAILS_LOADING",
    SET_POLICY_COMPONENT_DETAILS = "SET_POLICY_COMPONENT_DETAILS",
    SET_POLICY_COMPONENT_ASSOCIATED_POLICIES_LOADING = "SET_POLICY_COMPONENT_ASSOCIATED_POLICIES_LOADING",
    SET_POLICY_COMPONENT_ASSOCIATED_POLICIES = "SET_POLICY_COMPONENT_ASSOCIATED_POLICIES",
}

type SetPolicyComponentDetailsLoadingAction = {
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS_LOADING;
    payload: { isLoading: boolean; }
}

export const setPolicyComponentDetailsLoading = (isLoading: boolean): SetPolicyComponentDetailsLoadingAction => ({
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS_LOADING,
    payload: { isLoading }
});


type SetPolicyComponentAssociatedPoliciesLoadingAction = {
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES_LOADING;
    payload: { isLoading: boolean; }
}

export const setPolicyComponentAssociatedPoliciesLoading = (isLoading: boolean): SetPolicyComponentAssociatedPoliciesLoadingAction => ({
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES_LOADING,
    payload: { isLoading }
});

type SetPolicyComponentDetailsAction = {
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS;
    payload: { policyComponent: FormattedPolicyComponent; }
}

export const setPolicyComponentDetails = (policyComponent: FormattedPolicyComponent): SetPolicyComponentDetailsAction => ({
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_DETAILS,
    payload: { policyComponent }
});

type SetPolicyComponentAssociatedPoliciesAction = {
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES;
    payload: { associatedPolicies: Array<PolicyComponentAssociatedPolicy>; }
}

export const setPolicyComponentAssociatedPolicies = (associatedPolicies: Array<PolicyComponentAssociatedPolicy>): SetPolicyComponentAssociatedPoliciesAction => ({
    type: PolicyComponentDetailsActionTypes.SET_POLICY_COMPONENT_ASSOCIATED_POLICIES,
    payload: { associatedPolicies }
});


export type PolicyComponentDetailsActions =
    SetPolicyComponentDetailsLoadingAction |
    SetPolicyComponentDetailsAction |
    SetPolicyComponentAssociatedPoliciesLoadingAction |
    SetPolicyComponentAssociatedPoliciesAction